import { useEffect, FC } from 'react';

import MfaSetupForm from '../../Organisms/setting/MfaSetupForm';
import PortalHeader from '../../Organisms/header/PortalHeader';
import Footer from '../../Atoms/Footer';

type Props = {
  active: string;
  setActive: React.Dispatch<React.SetStateAction<string>>;
};

const MfaSetup: FC<Props> = ({ active, setActive }) => {
  useEffect(() => {
    setActive('settings');
  }, [setActive]);

  return (
    <>
      <PortalHeader active={active} setActive={setActive} />
      <MfaSetupForm />
      <Footer odd minHeihght="30vh" />
    </>
  );
};

export default MfaSetup;
